import React from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

interface Props {
  children: React.ReactNode;
  leftChildren: React.ReactNode;
}
const InvestmentsListWrapper: React.FC<Props> = ({ leftChildren, children }) => {
  const { isMobile } = useResponsive();
  return (
    <Box
      direction={isMobile ? 'column' : 'row'}
      round="moduleRound"
      pad="spacing24"
      background="border1"
      fill
      height={{ min: '400px' }}
    >
      <Box direction="column" justify="center" style={{ flex: 2 }}>
        {leftChildren}
      </Box>
      <Box direction="column" justify="center" style={{ flex: 4 }}>
        {children}
      </Box>
    </Box>
  );
};

export default InvestmentsListWrapper;
